import React from 'react';
import { Link } from 'react-router-dom';
import { Typography, Grid } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import { useOfflineAssets } from '../offline/useOfflineAssets';

interface Props {
    errorMessage?: string;
    refreshPage?: boolean;
}

export function PageNotFound(props:Props) {
    const { errorMessage, refreshPage } = props;
    const { onlineMode } = useOfflineAssets();

    return (
        <>
            <Grid container>
                <Grid item xs={12} sm={6} style={{margin: "5% auto"}}>
                    <Typography variant='h6' color="textSecondary" align='center'>
                        <ErrorIcon style={{ marginTop: "50px", width: "170px", height: "170px", color: "#CCC" }} /><br/>
                        {errorMessage ? errorMessage : "We're sorry, but we couldn't find the page you've requested."}
                        <br/>
                        { refreshPage
                            ? <a href={window.location.toString()}>Refresh</a>
                            : <Link to={onlineMode ? '/' : '/library-offline'} >Return to my library</Link>
                        }
                    </Typography>
                </Grid>
            </Grid>
        </>
    );
}